var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 70,
    viewBox: "0 0 117 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4123 28.8936V1.85673M29.2425 1.89061V28.8203M65.6318 1.81854H30.3609C27.4272 1.81854 24.9053 3.40012 24.3481 5.58939L17.2444 28.8924H88.1946L71.0966 4.37248C70.0544 2.80599 67.9412 1.81854 65.6318 1.81854Z",
    stroke: "#121330",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.838 36.5295H104.263C103.578 36.5287 102.9 36.6633 102.267 36.9256C101.634 37.1879 101.06 37.5728 100.576 38.0581C100.092 38.5421 99.7079 39.1169 99.4462 39.7496C99.1845 40.3824 99.0504 41.0605 99.0514 41.7452C99.0514 44.6229 101.386 46.9572 104.263 46.9572H114.183M1.72217 46.3591H9.90635",
    stroke: "#FAC02C",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.898 57.9629H38.1069M18.4355 57.9592H1.72192V45.0386C1.72192 36.1226 8.95315 28.8951 17.8657 28.8951H91.7112C104.428 28.8951 114.738 39.1986 114.738 51.9184V57.9592H97.5765M59.6349 40.5606H52.7196",
    stroke: "#121330",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2747 57.9599H28.271M87.7384 57.9599H87.7347M18.4329 57.9599C18.4329 63.3942 22.8385 67.7998 28.2728 67.7998C33.7072 67.7998 38.1128 63.3942 38.1128 57.9599C38.1128 52.5255 33.7072 48.1199 28.2728 48.1199C22.8385 48.1199 18.4329 52.5255 18.4329 57.9599ZM77.8966 57.9599C77.8966 63.3942 82.3022 67.7998 87.7366 67.7998C93.1709 67.7998 97.5765 63.3942 97.5765 57.9599C97.5765 52.5255 93.1709 48.1199 87.7366 48.1199C82.3022 48.1199 77.8966 52.5255 77.8966 57.9599Z",
    stroke: "#121330",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.c94b0be7a1fac8159d02687e461ae873.svg";
export { ForwardRef as ReactComponent };